import React from "react";
const SelectFieldLogin = ({
  label,
  options,
  name,
  size,
  placeholder,
  required,
  value,
  onChange,
  switchOptions,
  disabled,
}) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    onChange("select", name, value); // Call the parent's update function
  };

  return (
    <div className={"col-lg-" + size}>
      <div className="form-group">
        <div className="input-icon">
          <i className={label}></i>
        </div>

        <select
          className="form-select"
          required={required}
          name={name}
          value={value}
          disabled={disabled}
          onChange={handleChange}
        >
          <option value="">{placeholder}</option>
          {options.map((option, index) =>
            switchOptions === 1 ? (
              <option key={index} value={option.values}>
                {option.item}
              </option>
            ) : (
              <option key={index} value={option}>
                {option}
              </option>
            )
          )}
        </select>
      </div>
    </div>
  );
};

export default SelectFieldLogin;
